import React, {Component} from 'react';
import {Card, Divider, List, Typography} from "antd";
import {ProjectSelector} from "./ProjectSelector";
import {Controls} from "./Controls";

export default class DailyLogDetailsView extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = { projectname: this.props.projects ? '-AllProjects' : '' }
  }

  componentDidMount = () => this.props.onMount && this.props.onMount();

  handleChange = id => {
    const projectname = this.props.projects ? id ? ` - Project - ${this.props.projects.find(e => e.id === id).name}` : '- All Projects' : '';
    this.setState({ projectname });
    return this.props.updateFilters(id);
  };

  render() {
    const { projects, name, pdfGenerator } = this.props;
    let { report: { resource: data } = {} } = this.props;
    if (!data) return null;

    data.sort((a, b) => b._logdate === a._logdate ? b._datecreated - a._datecreated : b._logdate - a._logdate);

    return (
      <Card
        title={<h1>{name}</h1>}
        extra={[<Controls pdfGenerator={() => pdfGenerator(name + this.state.projectname)}/>]}
      >
        <ProjectSelector projects={projects} onSelect={this.handleChange}/>
        <List id='listElement' dataSource={data} renderItem={(log) => (
          <div className="upcoming-bid-details">
            <p><h1 className="color-primary-0">Daily Log #{log.number} - {log.logdate}</h1></p>
            <p>Created on {log.datecreated} by {log.createdby}</p>
            {(log.weather || (log.templo && log.temphi)) && <React.Fragment>
              <h4>Weather Info</h4>
              {log.weather && <p className='formatted-text'>{log.weather}</p>}
              {log.templo && log.temphi && <p>Temperatures ranged from {log.templo}°F to {log.temphi}°F</p>}
            </React.Fragment>}
            <h4>Safety Issues</h4>
            <p className='formatted-text'>{log.safetyissues || <Typography.Text type='secondary'>No safety issues reported.</Typography.Text>}</p>
            <h4>Weather Delays</h4>
            <p className='formatted-text'>{log.weatherdelays || <Typography.Text type='secondary'>No weather delays reported.</Typography.Text>}</p>
            <h4>Trade Delays</h4>
            <p className='formatted-text'>{log.tradedelays || <Typography.Text type='secondary'>No trade delays reported.</Typography.Text>}</p>
            <h4>Safety Delays</h4>
            <p className='formatted-text'>{log.safetydelays || <Typography.Text type='secondary'>No safety delays reported.</Typography.Text>}</p>
            <h4>Other Delays</h4>
            <p className='formatted-text'>{log.otherdelays || <Typography.Text type='secondary'>No other delays reported.</Typography.Text>}</p>
            <h4>Visitors</h4>
            <p className='formatted-text'>{log.visitors || <Typography.Text type='secondary'>No visitors reported.</Typography.Text>}</p>
            <h4>Subcontractors</h4>
            <p className='formatted-text'>{log.subcontractors || <Typography.Text type='secondary'>No subcontractors reported.</Typography.Text>}</p>
            <h4>Equipment</h4>
            <p className='formatted-text'>{log.equipment || <Typography.Text type='secondary'>No equipment reported.</Typography.Text>}</p>
            <h4>Summary</h4>
            <p className='formatted-text'>{log.summary}</p>
            <Divider style={{display: 'none'}}>-</Divider>
            <hr/>
          </div>
        )}/>
      </Card>
    );
  }
}






// WEBPACK FOOTER //
// ./src/components/Reports/DailyLogDetailsView.js